/* prettier-ignore */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { resolveTechModeEntry } from '../helpers/tech-mode-entry';
import { InformerModeEntryService } from '../services/informer-mode-entry.service';

/**
 * HRS-3145: guard de la ruta `/tech-mode/**`. Activa el modo del informador que
 * describe la URL y redirige al destino sin el prefijo. Nunca deja renderizar
 * nada: la ruta no tiene componente a propósito.
 */
export const techModeEntryGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);

  const entry = resolveTechModeEntry(state.url);
  if (!entry)
    return router.parseUrl('/home');

  inject(InformerModeEntryService).enter(entry.mode, entry.registerId);

  return router.parseUrl(entry.target);
};
